(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["whistle-cookie-preferences"] && !Shopify.designMode) return;
  try {
    (() => {
    let loadingBanner;
    function getBanner() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        return Promise.resolve(window.privacyBanner);
      }
      if (!loadingBanner) {
        loadingBanner = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.async = true;
          script.onload = () => {
            if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
              resolve(window.privacyBanner);
            } else {
              reject(new Error('Preferences unavailable'));
            }
          };
          script.onerror = reject;
          document.head.appendChild(script);
        }).catch((error) => {
          loadingBanner = null;
          throw error;
        });
      }
      return loadingBanner;
    }
    document.addEventListener('click', async (event) => {
      const link = event.target.closest('[data-whistle-cookie-preferences]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;
      link.setAttribute('aria-busy', 'true');
      try {
        const banner = await getBanner();
        await banner.showPreferences();
      } catch (_) {
        window.location.assign(link.href);
      } finally {
        link.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
